'use client'

import type { Modal } from '@/contentful/generated/schemas'

import { MemcoModal } from './modal'

type MemcoModalEmbeddedProps = {
  content: Modal
}

/**
 * Renders a Modal entry embedded in richtext.
 * Used when content editors embed modals directly in the Card's content richtext field.
 */
export function MemcoModalEmbedded({ content }: MemcoModalEmbeddedProps) {
  return <MemcoModal content={content} />
}
